export type TSeverity = "success" | "warning" | "error" | "info";

// Umbral (ARS) por encima del cual el costo promedio de un operador se resalta
// en rojo en el gráfico de costo por operador.
export const HIGH_COST_THRESHOLD = 5000;

export const getSlaRateSeverity = (rate: number): TSeverity => {
  if (rate <= 5) return "success";
  if (rate <= 15) return "warning";
  return "error";
};

export const getDeliveryRateSeverity = (rate: number): TSeverity => {
  if (rate >= 85) return "success";
  if (rate >= 70) return "warning";
  return "error";
};

// Cumplimiento de SLA: rojo si es menor al 50% (B2). Entre 50 y 85 es una
// advertencia; por encima, correcto.
export const getSlaComplianceSeverity = (rate: number): TSeverity => {
  if (rate < 50) return "error";
  if (rate < 85) return "warning";
  return "success";
};

// Calidad de servicio (B5). Métrica "positiva" (a más, mejor: entregas a tiempo,
// exitosas): roja por debajo del 50%. Métrica "negativa" (a más, peor: no
// entregados, devoluciones): roja por encima del 50%. En condiciones normales la
// barra queda verde.
export const getPositiveMetricSeverity = (rate: number): TSeverity =>
  rate < 50 ? "error" : "success";

export const getNegativeMetricSeverity = (rate: number): TSeverity =>
  rate > 50 ? "error" : "success";

export const SEVERITY_COLOR: Record<TSeverity, string> = {
  success: "#2e7d32",
  warning: "#e65100",
  error: "#c62828",
  info: "#0277bd",
};

export const SEVERITY_BG: Record<TSeverity, string> = {
  success: "#e8f5e9",
  warning: "#fff3e0",
  error: "#ffebee",
  info: "#e1f5fe",
};
